import { Component, OnInit } from '@angular/core';
import { MercaderiesService } from '../../../services/mercaderies.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UserService } from '../../../services/user.service';
import { global } from '../../../services/global';


@Component({
    selector: 'app-sortida-detail',
    templateUrl: './sortida-detail.component.html',
    styleUrls: ['./sortida-detail.component.scss']
})

export class SortidaDetailComponent implements OnInit {

    public error: string;
    public sortida: any;
    public partida: any;
    public documents: any;
    public url: string;

    constructor(
        private mercaderiesService: MercaderiesService,
        private userService: UserService,
        private router: Router,
        private route: ActivatedRoute
    ) {
        this.sortida = this.mercaderiesService.sortida;
        this.url = global.getUrl();
    }

    // An <img> cannot send the Authorization header, so the API reads the token from ?token=.
    downloadUrl(controller: string, documentId: number | string): string {
        return this.url + controller + '/download?id=' + documentId + '&token=' + encodeURIComponent(this.userService.getToken());
    }

    ngOnInit(): void {
        this.route.params.subscribe((params: Params) => {
            global.showPreloader = true;
            this.mercaderiesService.getSortida(this.userService.getToken(), params.id).subscribe(
                next => {
                    if (next.status === 'error') {
                        this.router.navigate(['/mercaderies/sortides']);
                    } else {
                        this.sortida = next.sortida;
                        this.documents = next.documents;
                        this.mercaderiesService.sortida = next.sortida;
                    }
                    global.showPreloader = false;
                },
                error => {
                    global.showPreloader = false;
                    this.router.navigate(['/mercaderies/sortides']);
                }
            );
        });
    }

    uploadFile(files: FileList, event): void {
        global.showPreloader = true;
        this.mercaderiesService.fileSortida(this.userService.getToken(), files.item(0)).subscribe(
            next => {
                event.target.type = '';
                event.target.type = 'file';
                this.mercaderiesService.getSortida(
                    this.userService.getToken(),
                    this.route.snapshot.params.id
                ).subscribe(
                    success => {
                        this.documents = success.documents;
                        global.showPreloader = false;
                    }, error => {
                        global.showPreloader = false;
                    }
                );
            }, error => {
                global.showPreloader = false;
                if (error.status === 401) {
                    this.router.navigate(['/logout/1']);
                } else {
                    this.error = error.error.message;
                }
            });
    }

    partidaChange(partida): void {
        if (partida.length === 6) {
            global.showPreloader = true;
            this.mercaderiesService.getSortidaPartida(this.userService.getToken(), this.sortida.idSortida, partida).subscribe(
                next => {
                    if (next.status === 'error') {
                        this.error = next.message;
                    } else {
                        this.mercaderiesService.partida = next.partida;
                        this.router.navigate(['/sortida-partida', next.sortida.idSortida, next.partida.idPartida]);
                    }
                    global.showPreloader = false;
                },
                error => {
                    global.showPreloader = false;
                    if (error.status === 401) {
                        this.router.navigate(['/logout/1']);
                    } else {
                        this.error = error.error.message;
                    }
                }
            );
        } else {
            this.error = '';
        }
    }

}
